if (!customElements.get('nuer-fragrance-filter')) {
  customElements.define('nuer-fragrance-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const controls = this.querySelector('[data-audience-controls]');
      if (!controls) return;
      const cards = [...this.querySelectorAll('[data-audience]')];
      controls.hidden = false;
      controls.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-filter]');
        if (!button) return;
        let visible = 0;
        cards.forEach((card) => {
          card.hidden = button.dataset.filter !== 'all' && !card.dataset.audience.split(',').includes(button.dataset.filter);
          if (!card.hidden) visible++;
        });
        controls.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelector('[data-filter-empty]').hidden = visible !== 0;
        this.querySelector('[data-filter-count]').textContent = `${visible} fragrances shown`;
      });
    }
  });
}
